import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { ThemeProvider } from './src/utils/themeContext';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};